module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section05_03_american-village-7aee50ba24c35d14ec6d3657a5bb92a2.jpg";